import { render, staticRenderFns } from "./appointmentDetails.vue?vue&type=template&id=52f30a04&scoped=true&"
import script from "./appointmentDetails.vue?vue&type=script&lang=js&"
export * from "./appointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDetails.vue?vue&type=style&index=0&id=52f30a04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f30a04",
  null
  
)

export default component.exports